import { render, staticRenderFns } from "./ValueActivitiesInfo.vue?vue&type=template&id=719ae5f2"
import script from "./ValueActivitiesInfo.vue?vue&type=script&lang=js"
export * from "./ValueActivitiesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports